import React from 'react'
import { ChordProvider as BaseChordProvider } from '@chordcommerce/react-autonomy'
import authClient from '~gatsby-theme-autonomy/services/auth'

const ReduxProvider = ({ children, options }) => {
  const chordConfigs = {
    ...options.omsConfig,
    currency: 'USD',
    locale: 'en-US',
  }

  return (
    <BaseChordProvider config={chordConfigs} auth={authClient}>
      {children}
    </BaseChordProvider>
  )
}

export default ReduxProvider
